<template>
  <div class="timerPie timerHolder">
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" pointer-events="none" :class="[statusClass, jangle]">
      <circle
        ref="bar"
        class="bar"
        r="25"
        cx="50"
        cy="50"
        stroke-width="50"
        transform="rotate(-90 50 50)"
        :style="{ strokeDasharray: c, strokeDashoffset: dash }"
      />
      <circle class="overdueRing" r="50" cy="50" cx="50" />
    </svg>

    <timer-setter v-if="phaseStore.settingUp" class="timerSetter" :type="props.type" />
  </div>
</template>
<script setup>
import { useTimeDisplay } from '@/composables/useTimeDisplay';
import TimerSetter from '@/components/TimerSetter.vue';
import { usePhaseStore } from '@/store/pinia/phase';
const phaseStore = usePhaseStore();
const props = defineProps({
  type: {
    default: 'phase',
  },
});

const { c, dash, statusClass, jangle, tickMs, barEasing } = useTimeDisplay({ r: 25, type: props.type });
</script>
<style scoped lang="scss">
.timerPie {
  position: relative;
  circle {
    fill: none;
  }
  .bar {
    stroke: currentColor;
    transition: all v-bind(tickMs) v-bind(barEasing);
  }
  .mid circle {
    color: var(--c__time-mid);
  }
  .end circle,
  .overdue circle {
    color: var(--c__time-over);
  }
  .jangle,
  .overdue {
    animation: overdue-jitter 2s linear 0s infinite;
    .overdueRing {
      fill: currentColor;
    }
  }
  .timerSetter {
    top: -2em;
    left: -2em;
    right: -2em;
    bottom: -2em;
  }
}
</style>
